import { useQuery } from "@tanstack/react-query";
import { getCompanyHours } from "../actions/getCompanyHours.action";
import { ETimePeriods } from "../enums/timesheets.enum";


export const useGetCompanyHours = (period: ETimePeriods) => {
    return useQuery({
        queryKey: ["company-hours", period],
        queryFn: () => getCompanyHours(period),
    });
}